import { Button, Stack, Typography } from '@mui/material';
import { useFinpspPaymentInstructions } from '../../../hooks/payment/finpsp/useFinpspPaymentInstructions';
import useLocalization from '../../../hooks/useLocalization';
import FinpspPaymentDetails from './FinpspPaymentDetails';
import FinpspPaymentLoading from './FinpspPaymentLoading';
import FinpspPaymentReference from './FinpspPaymentReference';
import FinpspPaymentStatus from './FinpspPaymentStatus';
import FinpspPaymentSteps from './FinpspPaymentSteps';

const styles = {
  root: {
    width: 1,
    flexShrink: 0,
    gap: 3,
  },
};

type FinpspPaymentInstructionsProps = {
  transactionId: string;
};

const FinpspPaymentInstructions = ({ transactionId }: FinpspPaymentInstructionsProps) => {
  const { t } = useLocalization();
  const { payment, copy, isError, refetch, showInstructions, checkoutUrl } =
    useFinpspPaymentInstructions(transactionId);

  if (!payment) {
    return <FinpspPaymentLoading isError={isError} onRetry={() => void refetch()} />;
  }

  return (
    <Stack direction='column' sx={styles.root}>
      <FinpspPaymentStatus payment={payment} />
      <FinpspPaymentDetails payment={payment} onCopy={copy} />
      {showInstructions && <FinpspPaymentSteps payment={payment} />}
      {checkoutUrl && <Button href={checkoutUrl}>{t('finpspContinuePayment')}</Button>}
      <FinpspPaymentReference payment={payment} />
      {isError && (
        <Typography variant='body2' color='text.secondary'>
          {t('finpspStatusUnavailable')}
        </Typography>
      )}
    </Stack>
  );
};

export default FinpspPaymentInstructions;
